import sharedEn from '@/lang/shared/en.json'
import en from './en.json'

export const sarkTranslations = {
  en: { ...sharedEn, ...en },
}
